<template>
  <v-tabs
    v-bind="[$attrs, $props]"
    color="blue"
    slider-color="blue"
    class="base-tab__tabs"
    v-on="$listeners"
  >
    <slot />
  </v-tabs>
</template>

<script>
export default {
  name: "BaseTab",
  props: ["value"]
};
</script>

<style lang="sass">
.base-tab__tabs
  .v-tabs-bar,
  .v-tabs-items
    background-color: var(--v-whiteSmoke-base) !important
  .v-tabs-bar
    border-bottom: 2px solid #E5E5ED
  .v-tab
    font-size: 16px
    font-weight: 400
    text-transform: uppercase !important
  .v-tab--active
    font-weight: 600 !important
    text-transform: uppercase !important
  .v-slide-group__prev--disabled
    display: none !important
</style>
